export default "<app-delta-volumi-tab [reportSection]=\"reportSection\"></app-delta-volumi-tab>\r\n";